
// ******************
//
// Ver.1.0
// Released on: July 27, 2023
// Phase 1.0
//
// ******************
import Vue from 'vue'
import { keyTypeScreenLogin } from '@/shared/constants'
import { filterDomain } from '@/shared/function'
import { UserTypeRole } from '@/shared/enums'

export default Vue.extend({
    name: 'LayoutFooterMain',
    computed: {
        isProvider(): boolean {
            return (
                this.typeRouter &&
                this.typeRouter.type === keyTypeScreenLogin.provider
            )
        },
        isAdmin() {
            return filterDomain().role === UserTypeRole.admin
        },
        isAdvisor() {
            return filterDomain().role === UserTypeRole.advisor
        }
    },
    created() {
        this.typeRouter = filterDomain()
    }
})
